import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { findGroupRoles } from "store/actions/groupRoleList";
import { groupRoleListSelectors } from "store/selectors";


export const useGroupRoles = () => {
	const isFetching = useSelector(groupRoleListSelectors.isFetching);
	const error = useSelector(groupRoleListSelectors.error);
	const roles = useSelector(groupRoleListSelectors.roles);

	useEffect(() => {
		const shouldFetch = !isNonEmptyArray(roles) && !isFetching && !error;

		if (shouldFetch) {
			findGroupRoles();
		}
	}, []);

	const getGroupRoleByName = useCallback(name => {
		const lcName = isNonEmptyString(name) ? name.toLowerCase() : name;
		let role = undefined;

		if (isNonEmptyArray(roles)) {
			role = roles.find(role => role.name.toLowerCase() === lcName);
		}

		return role;
	}, [ roles ]);

	return { roles, getGroupRoleByName };
};

export default useGroupRoles;
